<div class="sidebar-wrapper" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">

  <!-- Panel 1 — Brand / Logo -->
  <div class="sidebar-panel sidebar-brand-panel">
    <a *ngIf="isSidebarCollapsed" [routerLink]="'/dashboard'" class="sidebar-logo">C</a>
    <img
      *ngIf="!isSidebarCollapsed"
      (click)="goToDashboard()"
      src="/assets/images/logo.svg"
      class="sidebar-logo-img"
    />
  </div>

  <!-- Panel 2 — Menu Items -->
  <nav class="sidebar-panel sidebar-nav-panel">
    <span *ngIf="!isSidebarCollapsed" class="nav-section-label">Menu</span>
    <ul>
      <ng-container *ngFor="let item of menuItems">
        <li class="sidebar-menu-item">
          <a
            [routerLink]="item.routerLink"
            class="sidebar-item"
            routerLinkActive="menu-item-active"
            [ngClass]="{
              'has-children': item.children,
              'menu-item-active': item.isOpen
            }"
            (click)="toggleMenuItem(item)"
          >
            <span class="sidebar-item-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-item-text">{{ item.label }}</span>
            <i
              *ngIf="item.children && !isSidebarCollapsed"
              class="fas fa-chevron-down sidebar-item-arrow"
              [ngClass]="{ rotated: item.isOpen }"
            ></i>
          </a>
          <ul
            *ngIf="item.children && !isSidebarCollapsed && item.isOpen"
            class="sidebar-submenu"
          >
            <li *ngFor="let child of item.children">
              <a href="#" class="sidebar-item sidebar-subitem">
                <span class="sidebar-item-icon"><i [class]="child.icon"></i></span>
                <span class="sidebar-item-text">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nav>

  <!-- Panel 3 — Bottom: Hover‑reveal actions + Profile -->
  <div class="sidebar-bottom-area">
    <!-- Settings & Logout – hidden until sidebar hover -->
    <div class="sidebar-panel sidebar-system-panel">
      <ul>
        <li class="sidebar-menu-item">
          <a routerLink="/settings" class="sidebar-item" routerLinkActive="menu-item-active">
            <span class="sidebar-item-icon"><i class="fa-solid fa-gear"></i></span>
            <span class="sidebar-item-text">Settings</span>
          </a>
        </li>
        <li class="sidebar-menu-item" (click)="logout()">
          <a class="sidebar-item">
            <span class="sidebar-item-icon"><i class="fa-solid fa-power-off"></i></span>
            <span class="sidebar-item-text">Logout</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Profile card – always visible -->
    <div class="sidebar-panel sidebar-profile-panel">
      <span class="nav_image">
        <i class="fa-solid fa-circle-user default-avatar"></i>
        <img
          *ngIf="avatarUrl"
          [src]="avatarUrl"
          alt="Profile Picture"
          class="profile-picture"
          (error)="onImageError()"
        />
      </span>
      <div class="data_text">
        <span *ngIf="name" class="name">{{ name }}</span>
        <span class="email">{{ userName }}</span>
      </div>
    </div>
  </div>
</div>
